export default __webpack_public_path__ + "static/media/ruler.c048a94e.svg";